import { merge } from 'ramda';
import {
  LOAD_SLIP_TIMES_LIST_SUCCESS,
  CREATE_SLIP_TIME_REQUEST,
  CREATE_SLIP_TIME_SUCCESS,
  CREATE_SLIP_TIME_FAIL,
  UPDATE_SLIP_TIME_REQUEST,
  UPDATE_SLIP_TIME_SUCCESS,
  UPDATE_SLIP_TIME_FAIL,
  DELETE_SLIP_TIME_REQUEST,
  DELETE_SLIP_TIME_SUCCESS,
  DELETE_SLIP_TIME_FAIL,
  LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_SUCCESS,
  CREATE_SLIP_TIME_ASSOCIATIONS_REQUEST,
  CREATE_SLIP_TIME_ASSOCIATIONS_SUCCESS,
  CREATE_SLIP_TIME_ASSOCIATIONS_FAIL,
  DELETE_SLIP_TIME_ASSOCIATIONS_REQUEST,
  DELETE_SLIP_TIME_ASSOCIATIONS_SUCCESS,
  DELETE_SLIP_TIME_ASSOCIATIONS_FAIL
} from 'src/store/actions/slipTimesActions';

const initialState = {
  list: [],
  associations: [],
  fetching: 0
};

const slipTimesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SLIP_TIME_REQUEST:
    case UPDATE_SLIP_TIME_REQUEST:
    case DELETE_SLIP_TIME_REQUEST:
    case CREATE_SLIP_TIME_ASSOCIATIONS_REQUEST:
    case DELETE_SLIP_TIME_ASSOCIATIONS_REQUEST:
      return merge(state, { fetching: state.fetching + 1 });
    case CREATE_SLIP_TIME_FAIL:
    case UPDATE_SLIP_TIME_FAIL:
    case DELETE_SLIP_TIME_FAIL:
    case CREATE_SLIP_TIME_ASSOCIATIONS_FAIL:
    case DELETE_SLIP_TIME_ASSOCIATIONS_FAIL:
    case CREATE_SLIP_TIME_SUCCESS:
    case UPDATE_SLIP_TIME_SUCCESS:
    case DELETE_SLIP_TIME_SUCCESS:
    case CREATE_SLIP_TIME_ASSOCIATIONS_SUCCESS:
    case DELETE_SLIP_TIME_ASSOCIATIONS_SUCCESS:
      return merge(state, { fetching: state.fetching - 1 });
    case LOAD_SLIP_TIMES_LIST_SUCCESS:
      return merge(state, { list: action.list });
    case LOAD_SLIP_TIMES_ASSOCIATIONS_LIST_SUCCESS:
      return merge(state, { associations: action.associations });
    default:
      return state;
  }
};

export default slipTimesReducer;
